import * as React from 'react'

import { Icon, Select, SelectItem } from '../../components'

interface Props {
  domain?: string | null
  domainItems: SelectItem<string>[]
  isInteractive: boolean
}

const TICKER_HEADER_CONTAINER_CLASS_NAME = 'js-ticker-header-container'

export default function TrafficDomainSelect({ domain, domainItems, isInteractive }: Props) {
  const handleDomainSelect = React.useCallback(({ value }: { value: string }) => {
    const tickerHeaderContainer = document.getElementsByClassName(TICKER_HEADER_CONTAINER_CLASS_NAME)?.[0]
    const fvHeaderHeightInPx =
      Number.parseFloat(window.getComputedStyle(document.body).getPropertyValue('--fv-header-height')) || 0
    const element = document.getElementById(value)
    const elementTopPosition = element?.getBoundingClientRect().top ?? 0
    window.scrollTo({
      left: 0,
      top: window.scrollY + elementTopPosition - tickerHeaderContainer.clientHeight - fvHeaderHeightInPx - 1, // -1 because if it's not there sticky shadow is applied on domain header
      behavior: 'smooth',
    })
  }, [])

  return (
    <div className="-ml-2">
      <Select
        value={domain}
        theme="link"
        className="border-0"
        contentClass="text-xl font-bold"
        size="regular"
        focusRing={false}
        rightContent={<Icon name="chevronDown" width={24} />}
        items={domainItems}
        isInteractive={isInteractive}
        onChange={handleDomainSelect}
      />
    </div>
  )
}
